import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';

import { IBusinessPlanType } from 'interfaces/businessPlan';

export const getDocTitle = (type: IBusinessPlanType): string => {
  switch (type) {
    case BUSINESS_PLAN_TYPES.FOR_BANK:
      return 'For Bank';
    case BUSINESS_PLAN_TYPES.FOR_INVESTORS:
      return 'For Investors';
    default:
      return 'One Page';
  }
};
